"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MfaRegenerateRecoveryCodesRequestSchema () {
        return MfaRegenerateRecoveryCodesRequestSchema;
    },
    get MfaRegenerateRecoveryCodesResponseSchema () {
        return MfaRegenerateRecoveryCodesResponseSchema;
    }
});
const _zod = require("zod");
const MfaRegenerateRecoveryCodesRequestSchema = _zod.z.object({
    code: _zod.z.string().regex(/^\d{6}$/, 'code must be 6 digits')
}).strict();
const MfaRegenerateRecoveryCodesResponseSchema = _zod.z.object({
    recoveryCodes: _zod.z.array(_zod.z.string().min(1)).min(1)
}).strict();
